import { showNotice } from '../../Layout/Notices/Notices'
import { publishTrack, roomState, unpublishTrack } from '../webRTCRoom'

const getLocalScreenShareTrack = () => {
  const localParticipant = roomState.participants.find((p) => p.isLocal)
  return localParticipant?.tracks.screen?.mediaStream
}

const stopScreenSharing = () => {
  const localParticipant = roomState.participants.find((p) => p.isLocal)

  if (!localParticipant) return
  const videoTrack = localParticipant.tracks.screen
  const audioTrack = localParticipant.tracks.screenAudio

  if (videoTrack) {
    videoTrack.mediaStream.stop()
    unpublishTrack('screen')
  }

  if (audioTrack) {
    audioTrack.mediaStream.stop()
    unpublishTrack('screenAudio')
  }
}

const startScreenSharing = async () => {
  try {
    const stream = await navigator.mediaDevices.getDisplayMedia({
      audio: true,
      video: {
        width: { ideal: 1920 },
        frameRate: { ideal: 30 },
      },
    })
    const mediaStreamTrack = stream.getVideoTracks().at(0)
    const audioTrack = stream.getAudioTracks().at(0)

    if (mediaStreamTrack) {
      mediaStreamTrack.onended = stopScreenSharing
      publishTrack(mediaStreamTrack, 'screen')
      if (audioTrack) {
        publishTrack(audioTrack, 'screenAudio')
      }
    }
  } catch (e) {
    if (e instanceof Error && e.name === 'NotAllowedError') {
      showNotice({
        message: 'Failed to get permissions to share the screen.',
        cta: {
          link: 'https://www.twentythree.com/help/sharing-your-screen-and-slideshows-in-a-webinar',
          label: 'Get Help',
        },
        expirationMillis: 20e3,
        isClosable: true,
      })
    }
  }
}

const toggleScreenSharing = () => {
  const screenShareTrack = getLocalScreenShareTrack()
  return screenShareTrack?.enabled ? stopScreenSharing() : startScreenSharing()
}

export { toggleScreenSharing }
